import { useContent } from "@/context/ContentContext";
import Gallery from "@/components/site/Gallery";
import PageLoader from "@/components/site/PageLoader";

export default function GalleryPage() {
  const c = useContent();
  if (!c) return <PageLoader />;
  return <Gallery items={c.gallery || []} media={c.media} />;
}
